export class Attachments {
    public TicketNumber: string = "";
    public Username: string = "";
    public Adminname: string= "";
    public AttachmentURL: string = "";
    public AttachmentCreationTime: string = new Date().toISOString();
    
  }
  